module.exports = __webpack_public_path__ + "img/9791188299102.4b0d7edc.jpg";